import { SubscriptionSummary } from "@/types/businessData";
import { clsx, type ClassValue } from "clsx";
import { Timestamp } from "firebase/firestore";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function removeUndefinedProperties<T extends Record<string, any>>(
  obj: T
): T {
  return Object.fromEntries(
    Object.entries(obj).filter(([, value]) => value !== undefined)
  ) as T;
}

export function getCandidateAge(
  birthday: string | Timestamp | undefined
): number | null {
  if (!birthday) return null;

  let birthDate: Date;
  if (typeof birthday === "string") {
    // ISO date-only strings parse as UTC midnight; local getters then shift the
    // calendar day behind UTC (e.g. Americas). Parse YYYY-MM-DD as local calendar date.
    const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birthday.trim());
    if (dateOnly) {
      const y = Number(dateOnly[1]);
      const mo = Number(dateOnly[2]);
      const d = Number(dateOnly[3]);
      birthDate = new Date(y, mo - 1, d);
    } else {
      birthDate = new Date(birthday);
    }
  } else if (birthday instanceof Timestamp) {
    birthDate = birthday.toDate();
  } else if (typeof birthday === "object" && ("_seconds" in birthday || "seconds" in birthday)) {
    const secs = (birthday as any)._seconds ?? (birthday as any).seconds;
    birthDate = new Date(secs * 1000);
  } else {
    return null;
  }

  if (isNaN(birthDate.getTime())) return null;

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
}

export function isSubscriptionActive(
  subscription: SubscriptionSummary | null | undefined
): boolean {
  if (
    subscription &&
    subscription.status !== "trialing" &&
    subscription.status !== "active"
  ) {
    console.log("Subscription is not active", subscription);
    return false;
  }

  return true;
}

export function guardViewFromNotActive(
  subscription: SubscriptionSummary | null | undefined
): boolean {
  if (!isSubscriptionActive(subscription)) {
    return false;
  }

  return true;
}
